import Payload from './Payload';

class AdsControl {
  constructor(reload, localStorage) {
    this.constructedTime = Date.now();
    this.reload = reload;
    this.localStorage = localStorage;
    this.initialize();
    if (!this.isContinuation()) {
      this.reset();
      this.initialize();
    }
  }

  initialize() {
    this.payload = {};
    this.payloadMetadata = {};
    this.load('payload', {});
    this.load('payloadMetadata', {
      refreshTime: Date.now(),
      seen: 0,
    });
    console.log('AdsControl.initialize()');
    console.log(this.payload);
    this.adsInPayload = Payload.findAdsInPayload(this.payload);
  }

  setPayload(payload) {
    this.payload = payload;
    this.adsInPayload = Payload.findAdsInPayload(this.payload);
    this.save();
  }

  nextAd() {
    if (!this.hasANextAd()) {
      return false;
    }
    // send a message to the existing m2m-third-party script so that
    // it deregisters it's event listeners.
    window.top.postMessage(
      {
        action: 'deregister',
        m2m_impr_id: this.currentAd().impression_id,
        componentName: 'Card_0',
      },
      '*'
    );
    // advance to the next ad
    this.payloadMetadata.seen += 1;
    this.payloadMetadata.refreshTime = Date.now();
    // save state and reload
    this.save();
    this.reload();
    return true;
  }

  hasANextAd() {
    const ret = this.payloadMetadata.seen + 1 < this.adsInPayload.length;
    return ret;
  }

  hasExpired() {
    // if it takes longer than 5s to refresh, just ditch it.
    return this.constructedTime > this.payloadMetadata.refreshTime + 5000;
  }

  isContinuation() {
    return this.payloadMetadata.seen > 0 && this.adsInPayload.length > 0 && !this.hasExpired();
  }

  maybeContinue(preload) {
    if (this.isContinuation()) {
      preload(this.payload);
    }
  }

  currentAdIndex() {
    const ret = this.payloadMetadata.seen;
    return ret;
  }

  isFirstAd() {
    return this.currentAdIndex() === 0;
  }

  currentAd() {
    return this.adsInPayload[this.currentAdIndex()];
  }

  reset() {
    this.delete('payload');
    this.delete('payloadMetadata');
  }

  save() {
    console.log('AdsControl.save()');
    console.log(this.payload);
    this.localStorage.setItem('payload', JSON.stringify(this.payload));
    this.localStorage.setItem('payloadMetadata', JSON.stringify(this.payloadMetadata));
  }

  load(keyAndProperty, defaultValue = null) {
    console.log('AdsControl.load()');
    console.log(keyAndProperty);
    this[keyAndProperty] = this.localStorage.getItem(keyAndProperty);
    console.log(this[keyAndProperty]);
    if (this[keyAndProperty]) {
      this[keyAndProperty] = JSON.parse(this[keyAndProperty]);
    } else {
      this[keyAndProperty] = defaultValue;
    }
    return this[keyAndProperty];
  }

  delete(keyAndProperty) {
    this.localStorage.removeItem(keyAndProperty);
    this[keyAndProperty] = null;
  }
}

export default AdsControl;
